import React from 'react';
import './Loader.sass';

export default function Loader() {
  return (
    <div className="loader">
      <div className="circle" />
      <div className="title">
        Loading...
      </div>
    </div>
  );
}
